module.exports = __webpack_public_path__ + "img/img_hrdt_01.f22aa348.png";